export const OFFSET_FROM_CURSOR_IN_PX = 12;
